import type { ReactNode } from "react";
import type { Commune } from "models";
import { Link, Skeleton } from "@mui/material";
import { COLLECTIVITES_APP_DOMAIN_NAME } from "config/app-config";

interface CommuneLinkProps {
  commune: Commune;
  isLoading?: boolean;
}

export function CommuneLink({ commune, isLoading = false }: Readonly<CommuneLinkProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Link
      key={commune.id}
      target="_blank"
      href={`https://${COLLECTIVITES_APP_DOMAIN_NAME}/commune/${commune.id}`}>
      {commune.libelle}
    </Link>
  );
}
